"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLoadedInIFrame = void 0;
const isLoadedInIFrame = () => {
    return window.self !== window.top;
};
exports.isLoadedInIFrame = isLoadedInIFrame;
//# sourceMappingURL=helpers.js.map